import { httpService } from 'core/services/httpService';

const registerUser = ({body, otp}) => {
  return httpService.POST({url: `/user/register/${otp}`, body});
}

async function getAppState({data}, options={}) {
  const { pgId } = data
  return httpService.GET({url: `/${pgId}/pg/landing`}, {backgroundRequest: true, ...options});
}

const sendSignUpOTP = ({data = {}}) => {
  const { mobile } = data;
  return httpService.GET({url:`/user/${mobile}/sendOtp`});
}

async function signInUser({body, signal}) {
  return httpService.POST({url: '/authenticate', body}, {signal});
};

// async function logoutUser() {
//   return httpService.get({url: '/logout'});
// };

async function sendPasswordResetOTP({mobile}) {
  return httpService.GET({url: `/user/${mobile}/sendPasswordResetOtp` });
};

async function validateOTP(params) {
  return httpService.GET({url: `/user/validateOtp`, params});
};

async function resetPassword({data}){
  return httpService.PUT({url: '/user/resetPassword', body:{}, params: data});
};

async function getNewAccessToken({signal}){
  return httpService.GET({url: '/refreshToken',}, {signal, backgroundRequest: true});
};


// const DeleteUserInfoInBrowser = () => {
//   window.sessionStorage.removeItem('rpgmUserInfo');
//   window.sessionStorage.removeItem('pgc$token');
// }

function loader(){
  return {abc: true};
}

export { getAppState, signInUser, resetPassword, validateOTP, sendPasswordResetOTP, sendSignUpOTP, registerUser, getNewAccessToken , loader };
